import { Component } from '@angular/core';
import { OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../services/user.service';

/**
 * Component for refining a search using selected facet values.
 * Displays all facet values provided from the search.
 */
@Component({
  selector: 'all-facets',
  templateUrl: './all-facets.component.html',
  styleUrl: './all-facets.component.css'
})
export class AllFacetsComponent implements OnInit {
	@Input() facet: any;
	
	LOCALIZATION: any;
	
	facetfilter: string = "";
	values: any[] = []; // Tracks user selection to enable the Search button
	
	focused: boolean = false;
	
	constructor(
		private modalService: NgbActiveModal,
		private userService: UserService
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		this.toggleFacet();
	}
	
	toggleFacet(): void {
		this.values = [];
	    for (var i = 0; i < this.facet.value.length; i++) {
	        if (this.facet.value[i].checked) {
	            this.values.push(this.facet.value[i].quotifiedValue || this.facet.value[i].value);
	        }
	    }
	}
	
	/**
	 * Returns the selected facet values.
	 */
	search(): void {
		let caller = {
			callerName: 'allFacets'
		};
		
		this.modalService.close({facet: this.facet, caller: caller, answer: 'ok'});
	}
		
	/**
	 * Closes the modal.
	 */
	close(): void {
		this.modalService.dismiss();
	}
}
